import { render, staticRenderFns } from "./UpdateTeam.vue?vue&type=template&id=206eb47a&scoped=true&"
import script from "./UpdateTeam.vue?vue&type=script&lang=js&"
export * from "./UpdateTeam.vue?vue&type=script&lang=js&"
import style0 from "./UpdateTeam.vue?vue&type=style&index=0&id=206eb47a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206eb47a",
  null
  
)

export default component.exports